module.exports = "<div class=\"personalinfo-box\">\n    [firstname*]\n    [lastname*]\n    [address*]\n    [co]\n    [zipcode*]\n    [district*]\n    [phone*]\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./js-src/markdown-editor/modules/personalinfo/personalinfo.html
// module id = 33
// module chunks = 0 1